import React from "react";
import { Avatar, Badge } from "@mui/material";
import { initialsOf } from "./chatFormat";

/**
 * Participant avatar. `participant.image` is an absolute URL and may be null,
 * in which case MUI falls back to the rendered initial.
 */
const ChatAvatar = ({
  participant,
  size = 44,
  showPresence = false,
  isOnline = false,
}) => {
  const avatar = (
    <Avatar
      src={participant?.image || undefined}
      alt={participant?.name || "Profile"}
      sx={{
        width: size,
        height: size,
        bgcolor: "#ffe0c2",
        color: "#b35c00",
        fontSize: size / 2.4,
        fontWeight: 600,
      }}
    >
      {initialsOf(participant?.name)}
    </Avatar>
  );

  if (!showPresence) return avatar;

  return (
    <Badge
      overlap="circular"
      anchorOrigin={{ vertical: "bottom", horizontal: "right" }}
      variant="dot"
      sx={{
        "& .MuiBadge-badge": {
          width: 11,
          height: 11,
          borderRadius: "50%",
          backgroundColor: isOnline ? "#3fbf5f" : "#bdbdbd",
          boxShadow: "0 0 0 2px #fff",
        },
      }}
    >
      {avatar}
    </Badge>
  );
};

export default ChatAvatar;
